<ng-container
  *ngTemplateOutlet="
    (screenLayoutService.phone$ | async) ? phone : desktopTablet
  "
></ng-container>

<!-- phone screens -->
<ng-template #phone>
  <div class="mobile-list">
    @for (match of transformedMatches$ | async; track match) {
      <div
        class="mobile-item"
        [ngClass]="{
          clickable: true,
          highlighted: highlighted.has(match.id),
          disabled: match.disabled,
        }"
        (click)="!$event.target.matches('.solution') && clickRow(match)"
        (keyup.enter)="clickRow(match)"
        tabindex="0"
      >
        <sh-text size="body-2" color="secondary">Count</sh-text>
        <sh-text size="body-2" color="secondary">Pattern Type</sh-text>
        <span>{{ match.count }}</span>
        <span class="pattern-description">
          <span class="type">{{ match.pattern }}</span> -
          {{ match.patternDescription }}
        </span>
        <sh-text
          size="body-2"
          color="secondary"
          class="span-2 mobile-solutions-header"
          >Solution Proposition</sh-text
        >
        <span
          class="span-2 mobile-solutions"
          (click)="$event.stopPropagation()"
          (keyup.enter)="$event.stopPropagation()"
          tabindex="0"
        >
          <ng-container
            *ngTemplateOutlet="solutions; context: { $implicit: match }"
          ></ng-container>
        </span>
      </div>
    }
  </div>
</ng-template>

<!-- table -> large screens -->
<ng-template #desktopTablet>
  <div class="table">
    <ng-container
      *ngTemplateOutlet="header; context: { key: 'count', text: 'Count' }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        header;
        context: { key: 'pattern', text: 'Pattern Type' }
      "
    ></ng-container>
    <sh-text size="header-2">Solution Proposition</sh-text>
    @for (match of transformedMatches$ | async; track match) {
      <div
        class="item"
        [ngClass]="{
          clickable: true,
          highlighted: highlighted.has(match.id),
          disabled: match.disabled,
        }"
        (click)="clickRow(match)"
        (keyup.enter)="clickRow(match)"
        tabindex="0"
      >
        {{ match.count }}
      </div>
      <div
        class="item pattern-description"
        [ngClass]="{
          clickable: true,
          highlighted: highlighted.has(match.id),
          disabled: match.disabled,
        }"
        (click)="clickRow(match)"
        (keyup.enter)="clickRow(match)"
        tabindex="0"
      >
        <span class="type">{{ match.pattern }}</span>
        - {{ match.patternDescription }}
      </div>
      <div
        class="item solutions"
        [ngClass]="{
          highlighted: highlighted.has(match.id),
          disabled: match.disabled,
        }"
        (click)="clickRow(match)"
        (keyup.enter)="clickRow(match)"
        tabindex="0"
      >
        <ng-container
          *ngTemplateOutlet="solutions; context: { $implicit: match }"
        ></ng-container>
      </div>
    }
  </div>
</ng-template>

<!-- header with sorting behavior -->
<ng-template #header let-key="key" let-text="text">
  <sh-text size="header-2" (click)="toggleSort(key)">
    {{ text }}
    <!-- <sh-icon
      size="s"
      [icon]="(sortBy$ | async)?.ascending ? 'arrow-up-2' : 'arrow-down-2'"
      [ngClass]="{ hidden: (sortBy$ | async)?.key !== key }"
    ></sh-icon> -->
  </sh-text>
</ng-template>

<!-- instructions modal -->
<sh-modal
  [visible]="showInstructions"
  [label]="'solutionProposition.instructionText' | translate"
  (modal-closed)="showInstructions = false"
  modal-width="fit-content"
>
  <p class="modal-text">
    {{ instructions?.content }}
  </p>
  <sh-button
    slot="footer"
    label="Close"
    (click)="showInstructions = false"
  ></sh-button>
</sh-modal>

<ng-template #solutions let-match>
  <!-- prints match object -->
  <!-- <pre>{{ match | json }}</pre> -->

  @if (!match.solutionPropositions?.length) {
    <sh-text style="align-self: center" size="body-1" color="secondary"
      ><i>No solution propositions found</i></sh-text
    >
  }
  @for (solution of match.solutionPropositions; track solution) {
    @for (contents of solution.solutionPropositionContents; track contents) {
      <a
        class="solution"
        [attr.href]="contents.urlToWebsite || null"
        target="_blank"
        (click)="openSolution($event, solution, contents)"
      >
        <sh-icon [icon]="solution.icon" size="s"></sh-icon>
        @if (solution.type === 'instructionText') {
          {{ 'solutionProposition.instructionText' | translate }}
        }
        @if (solution.type !== 'instructionText') {
          {{ contents.content }}
        }
      </a>
    }
  }
</ng-template>
